import { Type } from '@angular/core';
import { Subscription } from 'rxjs';

import { HisDynamicFieldBase } from './field-base';
import { HisDynamicFieldConfig } from './formfield';

export class FieldsAndSubscriptions {

    private content: FieldAndSubscription[] = [];

    public add( field: HisDynamicFieldBase<any>, subscription: Subscription ): void {
        let name = field.name;
        if ( this.has( name ) ) {
            throw new Error( 'Tried to add second field with identical name \'' + name + '\' to ValueGroup' );
        } else {
            let newFieldAndSubscription = new FieldAndSubscription( name, field, subscription );
            this.content.push( newFieldAndSubscription );
        }
    }

    resetDynamicForm() {
        this.content.forEach(
            item => item.field.reset()
        );
    }

    public updateAllFieldConfigs( entireFormConfig: HisDynamicFieldConfig ) {
        this.content.forEach(
            item => {
                item.field.updateConfiguration( entireFormConfig );
            }
        );
    }

    public has( name: string ): boolean {
        return !!this.findFirstByName( name );
    }

    // in some cases empty values must be transferred
    public getJson( ignoreEmptyValues: boolean = true ): Record<string, any> {
        let params: Record<string, any> = {};
        this.content.forEach(
            item => {
                let value = item.field.getControlValue();
                if ( ( value || value === 0 ) || ( !ignoreEmptyValues && value !== null && value !== undefined ) ) {
                    params[item.field.name] = value;
                }
            }
        );
        return params;
    }

    public findFirstByName( name: string ): FieldAndSubscription {
        return this.content.find( item => item.isNamed( name ) );
    }

    public findFirstByType( type: Type<HisDynamicFieldBase<any>> ): HisDynamicFieldBase<any> {
        let fieldAndSub = this.content.find( item => item.field instanceof type );
        return fieldAndSub ? fieldAndSub.field : null;
    }

    public remove( name: string ): void {
        let itemToRemove = this.findFirstByName( name );
        if ( itemToRemove ) {
            itemToRemove.subscription.unsubscribe();
            this.content = this.content.filter(
                item => item.name !== name
            );
        }
    }

    public clear(): void {
        this.content.forEach(
            item => item.subscription.unsubscribe()
        );
        this.content = [];
    }
}

class FieldAndSubscription {

    name: string;
    field: HisDynamicFieldBase<any>;
    subscription: Subscription;

    constructor(
        name: string,
        field: HisDynamicFieldBase<any>,
        subscription: Subscription
    ) {
        this.name = name;
        this.field = field;
        this.subscription = subscription;
    }

    public isNamed( name: string ): boolean {
        return this.name === name;
    }
}
